@file:OptIn(InternalResourceApi::class)

package portalvv.shared.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/portalvv.shared.generated.resources/"

@delegate:ResourceContentHash(2_669_562)
internal val Res.string.announcements_action_view: StringResource by lazy {
      StringResource("string:announcements_action_view", "announcements_action_view", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 37),
      ))
    }

@delegate:ResourceContentHash(-1_005_076_039)
internal val Res.string.announcements_audience_all: StringResource by lazy {
      StringResource("string:announcements_audience_all", "announcements_audience_all", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 48, 58),
      ))
    }

@delegate:ResourceContentHash(-1_016_523_654)
internal val Res.string.announcements_audience_role: StringResource by lazy {
      StringResource("string:announcements_audience_role", "announcements_audience_role", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 174, 51),
      ))
    }

@delegate:ResourceContentHash(-385_796_497)
internal val Res.string.announcements_audience_roles_label: StringResource by lazy {
      StringResource("string:announcements_audience_roles_label", "announcements_audience_roles_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 107, 66),
      ))
    }

@delegate:ResourceContentHash(-257_812_294)
internal val Res.string.announcements_audience_title: StringResource by lazy {
      StringResource("string:announcements_audience_title", "announcements_audience_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 226, 80),
      ))
    }

@delegate:ResourceContentHash(-1_511_565_807)
internal val Res.string.announcements_audience_unit: StringResource by lazy {
      StringResource("string:announcements_audience_unit", "announcements_audience_unit", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 362, 51),
      ))
    }

@delegate:ResourceContentHash(1_326_500_476)
internal val Res.string.announcements_audience_units_label: StringResource by lazy {
      StringResource("string:announcements_audience_units_label", "announcements_audience_units_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 307, 54),
      ))
    }

@delegate:ResourceContentHash(-1_290_391_029)
internal val Res.string.announcements_audience_user: StringResource by lazy {
      StringResource("string:announcements_audience_user", "announcements_audience_user", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 469, 51),
      ))
    }

@delegate:ResourceContentHash(2_062_212_808)
internal val Res.string.announcements_audience_users_label: StringResource by lazy {
      StringResource("string:announcements_audience_users_label", "announcements_audience_users_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 414, 54),
      ))
    }

@delegate:ResourceContentHash(-747_396_985)
internal val Res.string.announcements_back: StringResource by lazy {
      StringResource("string:announcements_back", "announcements_back", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 521, 34),
      ))
    }

@delegate:ResourceContentHash(1_693_140_584)
internal val Res.string.announcements_close: StringResource by lazy {
      StringResource("string:announcements_close", "announcements_close", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 556, 35),
      ))
    }

@delegate:ResourceContentHash(1_539_054_651)
internal val Res.string.announcements_col_actions: StringResource by lazy {
      StringResource("string:announcements_col_actions", "announcements_col_actions", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 592, 45),
      ))
    }

@delegate:ResourceContentHash(778_129_060)
internal val Res.string.announcements_col_audience: StringResource by lazy {
      StringResource("string:announcements_col_audience", "announcements_col_audience", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 638, 54),
      ))
    }

@delegate:ResourceContentHash(1_815_879_383)
internal val Res.string.announcements_col_date: StringResource by lazy {
      StringResource("string:announcements_col_date", "announcements_col_date", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 693, 38),
      ))
    }

@delegate:ResourceContentHash(-1_814_740_775)
internal val Res.string.announcements_col_priority: StringResource by lazy {
      StringResource("string:announcements_col_priority", "announcements_col_priority", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 732, 50),
      ))
    }

@delegate:ResourceContentHash(-1_206_790_232)
internal val Res.string.announcements_col_status: StringResource by lazy {
      StringResource("string:announcements_col_status", "announcements_col_status", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 783, 48),
      ))
    }

@delegate:ResourceContentHash(-1_605_934_762)
internal val Res.string.announcements_col_title: StringResource by lazy {
      StringResource("string:announcements_col_title", "announcements_col_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 832, 43),
      ))
    }

@delegate:ResourceContentHash(327_415_701)
internal val Res.string.announcements_delete_message: StringResource by lazy {
      StringResource("string:announcements_delete_message", "announcements_delete_message", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 876, 152),
      ))
    }

@delegate:ResourceContentHash(882_378_833)
internal val Res.string.announcements_delete_title: StringResource by lazy {
      StringResource("string:announcements_delete_title", "announcements_delete_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1029, 58),
      ))
    }

@delegate:ResourceContentHash(778_129_060)
internal val Res.string.announcements_detail_audience: StringResource by lazy {
      StringResource("string:announcements_detail_audience", "announcements_detail_audience", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1088, 57),
      ))
    }

@delegate:ResourceContentHash(1_087_315_328)
internal val Res.string.announcements_detail_edited_at: StringResource by lazy {
      StringResource("string:announcements_detail_edited_at", "announcements_detail_edited_at", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1146, 62),
      ))
    }

@delegate:ResourceContentHash(976_862_855)
internal val Res.string.announcements_detail_published: StringResource by lazy {
      StringResource("string:announcements_detail_published", "announcements_detail_published", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1279, 54),
      ))
    }

@delegate:ResourceContentHash(-1_583_422_463)
internal val Res.string.announcements_detail_published_at: StringResource by lazy {
      StringResource("string:announcements_detail_published_at", "announcements_detail_published_at", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1209, 69),
      ))
    }

@delegate:ResourceContentHash(-984_811_786)
internal val Res.string.announcements_edit_title: StringResource by lazy {
      StringResource("string:announcements_edit_title", "announcements_edit_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1334, 56),
      ))
    }

@delegate:ResourceContentHash(1_230_990_720)
internal val Res.string.announcements_email_hint: StringResource by lazy {
      StringResource("string:announcements_email_hint", "announcements_email_hint", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1391, 148),
      ))
    }

@delegate:ResourceContentHash(1_657_965)
internal val Res.string.announcements_empty_value: StringResource by lazy {
      StringResource("string:announcements_empty_value", "announcements_empty_value", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1540, 37),
      ))
    }

@delegate:ResourceContentHash(-223_529_341)
internal val Res.string.announcements_field_content: StringResource by lazy {
      StringResource("string:announcements_field_content", "announcements_field_content", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1578, 47),
      ))
    }

@delegate:ResourceContentHash(-1_917_311_627)
internal val Res.string.announcements_field_image: StringResource by lazy {
      StringResource("string:announcements_field_image", "announcements_field_image", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1674, 57),
      ))
    }

@delegate:ResourceContentHash(29_385_265)
internal val Res.string.announcements_field_image_plain: StringResource by lazy {
      StringResource("string:announcements_field_image_plain", "announcements_field_image_plain", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1626, 47),
      ))
    }

@delegate:ResourceContentHash(1_170_910_461)
internal val Res.string.announcements_form_title: StringResource by lazy {
      StringResource("string:announcements_form_title", "announcements_form_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1732, 48),
      ))
    }

@delegate:ResourceContentHash(-1_264_578_428)
internal val Res.string.announcements_format_align_center: StringResource by lazy {
      StringResource("string:announcements_format_align_center", "announcements_format_align_center", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1781, 57),
      ))
    }

@delegate:ResourceContentHash(606_073_746)
internal val Res.string.announcements_format_align_end: StringResource by lazy {
      StringResource("string:announcements_format_align_end", "announcements_format_align_end", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1839, 62),
      ))
    }

@delegate:ResourceContentHash(-1_475_817_289)
internal val Res.string.announcements_format_align_justify: StringResource by lazy {
      StringResource("string:announcements_format_align_justify", "announcements_format_align_justify", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1902, 58),
      ))
    }

@delegate:ResourceContentHash(-60_166_049)
internal val Res.string.announcements_format_align_start: StringResource by lazy {
      StringResource("string:announcements_format_align_start", "announcements_format_align_start", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1961, 68),
      ))
    }

@delegate:ResourceContentHash(519_554_324)
internal val Res.string.announcements_format_bold: StringResource by lazy {
      StringResource("string:announcements_format_bold", "announcements_format_bold", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2030, 45),
      ))
    }

@delegate:ResourceContentHash(238_365_326)
internal val Res.string.announcements_format_bullet: StringResource by lazy {
      StringResource("string:announcements_format_bullet", "announcements_format_bullet", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2076, 63),
      ))
    }

@delegate:ResourceContentHash(1_371_023_684)
internal val Res.string.announcements_format_clear: StringResource by lazy {
      StringResource("string:announcements_format_clear", "announcements_format_clear", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2140, 62),
      ))
    }

@delegate:ResourceContentHash(1_948_131_647)
internal val Res.string.announcements_format_code: StringResource by lazy {
      StringResource("string:announcements_format_code", "announcements_format_code", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2203, 57),
      ))
    }

@delegate:ResourceContentHash(2_101_556_366)
internal val Res.string.announcements_format_heading1: StringResource by lazy {
      StringResource("string:announcements_format_heading1", "announcements_format_heading1", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2261, 57),
      ))
    }

@delegate:ResourceContentHash(-145_934_145)
internal val Res.string.announcements_format_heading2: StringResource by lazy {
      StringResource("string:announcements_format_heading2", "announcements_format_heading2", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2319, 57),
      ))
    }

@delegate:ResourceContentHash(-1_306_548_848)
internal val Res.string.announcements_format_heading3: StringResource by lazy {
      StringResource("string:announcements_format_heading3", "announcements_format_heading3", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2377, 57),
      ))
    }

@delegate:ResourceContentHash(-692_531_782)
internal val Res.string.announcements_format_indent_decrease: StringResource by lazy {
      StringResource("string:announcements_format_indent_decrease", "announcements_format_indent_decrease", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2435, 64),
      ))
    }

@delegate:ResourceContentHash(1_540_408_304)
internal val Res.string.announcements_format_indent_increase: StringResource by lazy {
      StringResource("string:announcements_format_indent_increase", "announcements_format_indent_increase", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2500, 64),
      ))
    }

@delegate:ResourceContentHash(259_411_219)
internal val Res.string.announcements_format_italic: StringResource by lazy {
      StringResource("string:announcements_format_italic", "announcements_format_italic", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2565, 47),
      ))
    }

@delegate:ResourceContentHash(-853_987_017)
internal val Res.string.announcements_format_link: StringResource by lazy {
      StringResource("string:announcements_format_link", "announcements_format_link", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2613, 49),
      ))
    }

@delegate:ResourceContentHash(-1_365_543_951)
internal val Res.string.announcements_format_ordered: StringResource by lazy {
      StringResource("string:announcements_format_ordered", "announcements_format_ordered", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2663, 56),
      ))
    }

@delegate:ResourceContentHash(920_091_502)
internal val Res.string.announcements_format_redo: StringResource by lazy {
      StringResource("string:announcements_format_redo", "announcements_format_redo", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2720, 45),
      ))
    }

@delegate:ResourceContentHash(-1_757_948_171)
internal val Res.string.announcements_format_strike: StringResource by lazy {
      StringResource("string:announcements_format_strike", "announcements_format_strike", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2766, 47),
      ))
    }

@delegate:ResourceContentHash(365_388_639)
internal val Res.string.announcements_format_underline: StringResource by lazy {
      StringResource("string:announcements_format_underline", "announcements_format_underline", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2814, 54),
      ))
    }

@delegate:ResourceContentHash(23_388_526)
internal val Res.string.announcements_format_undo: StringResource by lazy {
      StringResource("string:announcements_format_undo", "announcements_format_undo", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2869, 45),
      ))
    }

@delegate:ResourceContentHash(2_022_437_108)
internal val Res.string.announcements_image_remove: StringResource by lazy {
      StringResource("string:announcements_image_remove", "announcements_image_remove", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2915, 54),
      ))
    }

@delegate:ResourceContentHash(684_059_690)
internal val Res.string.announcements_image_resources: StringResource by lazy {
      StringResource("string:announcements_image_resources", "announcements_image_resources", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2970, 61),
      ))
    }

@delegate:ResourceContentHash(883_729_568)
internal val Res.string.announcements_image_send: StringResource by lazy {
      StringResource("string:announcements_image_send", "announcements_image_send", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3032, 56),
      ))
    }

@delegate:ResourceContentHash(-1_947_522_520)
internal val Res.string.announcements_image_upload: StringResource by lazy {
      StringResource("string:announcements_image_upload", "announcements_image_upload", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3296, 42),
      ))
    }

@delegate:ResourceContentHash(854_107_557)
internal val Res.string.announcements_image_upload_hint: StringResource by lazy {
      StringResource("string:announcements_image_upload_hint", "announcements_image_upload_hint", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3089, 83),
      ))
    }

@delegate:ResourceContentHash(-1_731_917_962)
internal val Res.string.announcements_image_upload_unsupported: StringResource by lazy {
      StringResource("string:announcements_image_upload_unsupported", "announcements_image_upload_unsupported", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3173, 122),
      ))
    }

@delegate:ResourceContentHash(-1_928_313_487)
internal val Res.string.announcements_link_confirm: StringResource by lazy {
      StringResource("string:announcements_link_confirm", "announcements_link_confirm", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3339, 46),
      ))
    }

@delegate:ResourceContentHash(1_848_012_991)
internal val Res.string.announcements_link_url: StringResource by lazy {
      StringResource("string:announcements_link_url", "announcements_link_url", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3386, 74),
      ))
    }

@delegate:ResourceContentHash(1_475_874_715)
internal val Res.string.announcements_more_items: StringResource by lazy {
      StringResource("string:announcements_more_items", "announcements_more_items", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3461, 44),
      ))
    }

@delegate:ResourceContentHash(446_884_524)
internal val Res.string.announcements_new_title: StringResource by lazy {
      StringResource("string:announcements_new_title", "announcements_new_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3506, 51),
      ))
    }

@delegate:ResourceContentHash(-891_500_590)
internal val Res.string.announcements_no_options: StringResource by lazy {
      StringResource("string:announcements_no_options", "announcements_no_options", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3558, 72),
      ))
    }

@delegate:ResourceContentHash(-1_891_668_081)
internal val Res.string.announcements_priority_help: StringResource by lazy {
      StringResource("string:announcements_priority_help", "announcements_priority_help", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3631, 339),
      ))
    }

@delegate:ResourceContentHash(1_994_573_732)
internal val Res.string.announcements_priority_high_desc: StringResource by lazy {
      StringResource("string:announcements_priority_high_desc", "announcements_priority_high_desc", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3971, 164),
      ))
    }

@delegate:ResourceContentHash(-1_018_172_222)
internal val Res.string.announcements_priority_info_hint: StringResource by lazy {
      StringResource("string:announcements_priority_info_hint", "announcements_priority_info_hint", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4136, 132),
      ))
    }

@delegate:ResourceContentHash(1_212_968_545)
internal val Res.string.announcements_priority_info_title: StringResource by lazy {
      StringResource("string:announcements_priority_info_title", "announcements_priority_info_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4269, 77),
      ))
    }

@delegate:ResourceContentHash(908_485_849)
internal val Res.string.announcements_priority_low_desc: StringResource by lazy {
      StringResource("string:announcements_priority_low_desc", "announcements_priority_low_desc", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4347, 115),
      ))
    }

@delegate:ResourceContentHash(1_348_789_389)
internal val Res.string.announcements_priority_medium_desc: StringResource by lazy {
      StringResource("string:announcements_priority_medium_desc", "announcements_priority_medium_desc", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4463, 106),
      ))
    }

@delegate:ResourceContentHash(2_103_720_444)
internal val Res.string.announcements_publish: StringResource by lazy {
      StringResource("string:announcements_publish", "announcements_publish", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4862, 41),
      ))
    }

@delegate:ResourceContentHash(414_439_073)
internal val Res.string.announcements_publish_confirm: StringResource by lazy {
      StringResource("string:announcements_publish_confirm", "announcements_publish_confirm", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4570, 133),
      ))
    }

@delegate:ResourceContentHash(1_476_179_421)
internal val Res.string.announcements_publish_success: StringResource by lazy {
      StringResource("string:announcements_publish_success", "announcements_publish_success", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4704, 93),
      ))
    }

@delegate:ResourceContentHash(-46_085_605)
internal val Res.string.announcements_publish_title: StringResource by lazy {
      StringResource("string:announcements_publish_title", "announcements_publish_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4798, 63),
      ))
    }

@delegate:ResourceContentHash(-989_284_405)
internal val Res.string.announcements_retry: StringResource by lazy {
      StringResource("string:announcements_retry", "announcements_retry", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4904, 51),
      ))
    }

@delegate:ResourceContentHash(-499_594_546)
internal val Res.string.announcements_save_draft: StringResource by lazy {
      StringResource("string:announcements_save_draft", "announcements_save_draft", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4956, 52),
      ))
    }

@delegate:ResourceContentHash(852_351_757)
internal val Res.string.announcements_search: StringResource by lazy {
      StringResource("string:announcements_search", "announcements_search", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5078, 36),
      ))
    }

@delegate:ResourceContentHash(-604_246_681)
internal val Res.string.announcements_search_placeholder: StringResource by lazy {
      StringResource("string:announcements_search_placeholder", "announcements_search_placeholder", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5009, 68),
      ))
    }

@delegate:ResourceContentHash(-1_807_153_672)
internal val Res.string.announcements_select_all: StringResource by lazy {
      StringResource("string:announcements_select_all", "announcements_select_all", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5115, 56),
      ))
    }

@delegate:ResourceContentHash(-1_949_577_755)
internal val Res.string.announcements_select_placeholder: StringResource by lazy {
      StringResource("string:announcements_select_placeholder", "announcements_select_placeholder", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5172, 56),
      ))
    }

@delegate:ResourceContentHash(-1_400_446_765)
internal val Res.string.announcements_target_roles: StringResource by lazy {
      StringResource("string:announcements_target_roles", "announcements_target_roles", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5229, 62),
      ))
    }

@delegate:ResourceContentHash(-544_920_898)
internal val Res.string.announcements_target_units: StringResource by lazy {
      StringResource("string:announcements_target_units", "announcements_target_units", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5292, 54),
      ))
    }

@delegate:ResourceContentHash(353_265_820)
internal val Res.string.announcements_target_users: StringResource by lazy {
      StringResource("string:announcements_target_users", "announcements_target_users", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5347, 50),
      ))
    }

@delegate:ResourceContentHash(-191_602_269)
internal val Res.string.announcements_view_preview: StringResource by lazy {
      StringResource("string:announcements_view_preview", "announcements_view_preview", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5398, 50),
      ))
    }

@delegate:ResourceContentHash(-99_452_054)
internal val Res.string.app_access_denied_message: StringResource by lazy {
      StringResource("string:app_access_denied_message", "app_access_denied_message", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5449, 105),
      ))
    }

@delegate:ResourceContentHash(1_726_652_435)
internal val Res.string.app_access_denied_title: StringResource by lazy {
      StringResource("string:app_access_denied_title", "app_access_denied_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5555, 59),
      ))
    }

@delegate:ResourceContentHash(-955_956_522)
internal val Res.string.app_go_home: StringResource by lazy {
      StringResource("string:app_go_home", "app_go_home", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5615, 47),
      ))
    }

@delegate:ResourceContentHash(326_828_967)
internal val Res.string.app_load_error: StringResource by lazy {
      StringResource("string:app_load_error", "app_load_error", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5663, 82),
      ))
    }

@delegate:ResourceContentHash(1_071_695_927)
internal val Res.string.app_name: StringResource by lazy {
      StringResource("string:app_name", "app_name", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5746, 32),
      ))
    }

@delegate:ResourceContentHash(-1_972_891_150)
internal val Res.string.audit_action_details: StringResource by lazy {
      StringResource("string:audit_action_details", "audit_action_details", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5779, 40),
      ))
    }

@delegate:ResourceContentHash(353_503_308)
internal val Res.string.audit_apply: StringResource by lazy {
      StringResource("string:audit_apply", "audit_apply", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5820, 31),
      ))
    }

@delegate:ResourceContentHash(515_583_929)
internal val Res.string.audit_cancel: StringResource by lazy {
      StringResource("string:audit_cancel", "audit_cancel", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5852, 32),
      ))
    }

@delegate:ResourceContentHash(1_539_054_651)
internal val Res.string.audit_col_actions: StringResource by lazy {
      StringResource("string:audit_col_actions", "audit_col_actions", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5885, 37),
      ))
    }

@delegate:ResourceContentHash(-66_109_194)
internal val Res.string.audit_col_code: StringResource by lazy {
      StringResource("string:audit_col_code", "audit_col_code", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5923, 34),
      ))
    }

@delegate:ResourceContentHash(1_815_879_383)
internal val Res.string.audit_col_date: StringResource by lazy {
      StringResource("string:audit_col_date", "audit_col_date", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5958, 30),
      ))
    }

@delegate:ResourceContentHash(-1_388_323_554)
internal val Res.string.audit_col_description: StringResource by lazy {
      StringResource("string:audit_col_description", "audit_col_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5989, 45),
      ))
    }

@delegate:ResourceContentHash(2_556_910)
internal val Res.string.audit_col_id: StringResource by lazy {
      StringResource("string:audit_col_id", "audit_col_id", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6035, 24),
      ))
    }

@delegate:ResourceContentHash(623_921_818)
internal val Res.string.audit_col_module: StringResource by lazy {
      StringResource("string:audit_col_module", "audit_col_module", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6060, 36),
      ))
    }

@delegate:ResourceContentHash(174_870_153)
internal val Res.string.audit_col_result: StringResource by lazy {
      StringResource("string:audit_col_result", "audit_col_result", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6097, 36),
      ))
    }

@delegate:ResourceContentHash(-2_075_472_046)
internal val Res.string.audit_col_user: StringResource by lazy {
      StringResource("string:audit_col_user", "audit_col_user", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6134, 34),
      ))
    }

@delegate:ResourceContentHash(1_840_043_020)
internal val Res.string.audit_custom_end: StringResource by lazy {
      StringResource("string:audit_custom_end", "audit_custom_end", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6169, 40),
      ))
    }

@delegate:ResourceContentHash(2_082_143_795)
internal val Res.string.audit_custom_start: StringResource by lazy {
      StringResource("string:audit_custom_start", "audit_custom_start", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6210, 42),
      ))
    }

@delegate:ResourceContentHash(1_132_040_607)
internal val Res.string.audit_custom_title: StringResource by lazy {
      StringResource("string:audit_custom_title", "audit_custom_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6253, 58),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("announcements_action_view", Res.string.announcements_action_view)
  map.put("announcements_audience_all", Res.string.announcements_audience_all)
  map.put("announcements_audience_role", Res.string.announcements_audience_role)
  map.put("announcements_audience_roles_label", Res.string.announcements_audience_roles_label)
  map.put("announcements_audience_title", Res.string.announcements_audience_title)
  map.put("announcements_audience_unit", Res.string.announcements_audience_unit)
  map.put("announcements_audience_units_label", Res.string.announcements_audience_units_label)
  map.put("announcements_audience_user", Res.string.announcements_audience_user)
  map.put("announcements_audience_users_label", Res.string.announcements_audience_users_label)
  map.put("announcements_back", Res.string.announcements_back)
  map.put("announcements_close", Res.string.announcements_close)
  map.put("announcements_col_actions", Res.string.announcements_col_actions)
  map.put("announcements_col_audience", Res.string.announcements_col_audience)
  map.put("announcements_col_date", Res.string.announcements_col_date)
  map.put("announcements_col_priority", Res.string.announcements_col_priority)
  map.put("announcements_col_status", Res.string.announcements_col_status)
  map.put("announcements_col_title", Res.string.announcements_col_title)
  map.put("announcements_delete_message", Res.string.announcements_delete_message)
  map.put("announcements_delete_title", Res.string.announcements_delete_title)
  map.put("announcements_detail_audience", Res.string.announcements_detail_audience)
  map.put("announcements_detail_edited_at", Res.string.announcements_detail_edited_at)
  map.put("announcements_detail_published", Res.string.announcements_detail_published)
  map.put("announcements_detail_published_at", Res.string.announcements_detail_published_at)
  map.put("announcements_edit_title", Res.string.announcements_edit_title)
  map.put("announcements_email_hint", Res.string.announcements_email_hint)
  map.put("announcements_empty_value", Res.string.announcements_empty_value)
  map.put("announcements_field_content", Res.string.announcements_field_content)
  map.put("announcements_field_image", Res.string.announcements_field_image)
  map.put("announcements_field_image_plain", Res.string.announcements_field_image_plain)
  map.put("announcements_form_title", Res.string.announcements_form_title)
  map.put("announcements_format_align_center", Res.string.announcements_format_align_center)
  map.put("announcements_format_align_end", Res.string.announcements_format_align_end)
  map.put("announcements_format_align_justify", Res.string.announcements_format_align_justify)
  map.put("announcements_format_align_start", Res.string.announcements_format_align_start)
  map.put("announcements_format_bold", Res.string.announcements_format_bold)
  map.put("announcements_format_bullet", Res.string.announcements_format_bullet)
  map.put("announcements_format_clear", Res.string.announcements_format_clear)
  map.put("announcements_format_code", Res.string.announcements_format_code)
  map.put("announcements_format_heading1", Res.string.announcements_format_heading1)
  map.put("announcements_format_heading2", Res.string.announcements_format_heading2)
  map.put("announcements_format_heading3", Res.string.announcements_format_heading3)
  map.put("announcements_format_indent_decrease", Res.string.announcements_format_indent_decrease)
  map.put("announcements_format_indent_increase", Res.string.announcements_format_indent_increase)
  map.put("announcements_format_italic", Res.string.announcements_format_italic)
  map.put("announcements_format_link", Res.string.announcements_format_link)
  map.put("announcements_format_ordered", Res.string.announcements_format_ordered)
  map.put("announcements_format_redo", Res.string.announcements_format_redo)
  map.put("announcements_format_strike", Res.string.announcements_format_strike)
  map.put("announcements_format_underline", Res.string.announcements_format_underline)
  map.put("announcements_format_undo", Res.string.announcements_format_undo)
  map.put("announcements_image_remove", Res.string.announcements_image_remove)
  map.put("announcements_image_resources", Res.string.announcements_image_resources)
  map.put("announcements_image_send", Res.string.announcements_image_send)
  map.put("announcements_image_upload", Res.string.announcements_image_upload)
  map.put("announcements_image_upload_hint", Res.string.announcements_image_upload_hint)
  map.put("announcements_image_upload_unsupported", Res.string.announcements_image_upload_unsupported)
  map.put("announcements_link_confirm", Res.string.announcements_link_confirm)
  map.put("announcements_link_url", Res.string.announcements_link_url)
  map.put("announcements_more_items", Res.string.announcements_more_items)
  map.put("announcements_new_title", Res.string.announcements_new_title)
  map.put("announcements_no_options", Res.string.announcements_no_options)
  map.put("announcements_priority_help", Res.string.announcements_priority_help)
  map.put("announcements_priority_high_desc", Res.string.announcements_priority_high_desc)
  map.put("announcements_priority_info_hint", Res.string.announcements_priority_info_hint)
  map.put("announcements_priority_info_title", Res.string.announcements_priority_info_title)
  map.put("announcements_priority_low_desc", Res.string.announcements_priority_low_desc)
  map.put("announcements_priority_medium_desc", Res.string.announcements_priority_medium_desc)
  map.put("announcements_publish", Res.string.announcements_publish)
  map.put("announcements_publish_confirm", Res.string.announcements_publish_confirm)
  map.put("announcements_publish_success", Res.string.announcements_publish_success)
  map.put("announcements_publish_title", Res.string.announcements_publish_title)
  map.put("announcements_retry", Res.string.announcements_retry)
  map.put("announcements_save_draft", Res.string.announcements_save_draft)
  map.put("announcements_search", Res.string.announcements_search)
  map.put("announcements_search_placeholder", Res.string.announcements_search_placeholder)
  map.put("announcements_select_all", Res.string.announcements_select_all)
  map.put("announcements_select_placeholder", Res.string.announcements_select_placeholder)
  map.put("announcements_target_roles", Res.string.announcements_target_roles)
  map.put("announcements_target_units", Res.string.announcements_target_units)
  map.put("announcements_target_users", Res.string.announcements_target_users)
  map.put("announcements_view_preview", Res.string.announcements_view_preview)
  map.put("app_access_denied_message", Res.string.app_access_denied_message)
  map.put("app_access_denied_title", Res.string.app_access_denied_title)
  map.put("app_go_home", Res.string.app_go_home)
  map.put("app_load_error", Res.string.app_load_error)
  map.put("app_name", Res.string.app_name)
  map.put("audit_action_details", Res.string.audit_action_details)
  map.put("audit_apply", Res.string.audit_apply)
  map.put("audit_cancel", Res.string.audit_cancel)
  map.put("audit_col_actions", Res.string.audit_col_actions)
  map.put("audit_col_code", Res.string.audit_col_code)
  map.put("audit_col_date", Res.string.audit_col_date)
  map.put("audit_col_description", Res.string.audit_col_description)
  map.put("audit_col_id", Res.string.audit_col_id)
  map.put("audit_col_module", Res.string.audit_col_module)
  map.put("audit_col_result", Res.string.audit_col_result)
  map.put("audit_col_user", Res.string.audit_col_user)
  map.put("audit_custom_end", Res.string.audit_custom_end)
  map.put("audit_custom_start", Res.string.audit_custom_start)
  map.put("audit_custom_title", Res.string.audit_custom_title)
}
